import { twMerge } from '@/lib/classname/twMerge'

type TableEmptyStateProps = {
  // The message displayed on the empty row
  label: string
  // Optional button to reset filter, redirect, etc
  button?: React.ReactElement
}

export function Empty({ label, button }: TableEmptyStateProps) {
  return (
    <div
      className={twMerge(
        'flex w-full flex-col items-start justify-start gap-2 bg-white p-3 desktop:h-[4.25rem]',
        'desktop:flex-row desktop:items-center desktop:justify-between desktop:align-middle',
      )}
      data-testid="table/empty-state"
    >
      <p className="text-md font-bold leading-light text-brand-2-900">{label}</p>
      {!!button && button}
    </div>
  )
}
